import React, { useEffect } from "react";
import "./style.css";
import { Reveal } from "../../Components/Reveal/Reveal";
import { Button } from "../../Components/Button/Button";
import officeImg from "../../Assets/nastuh-abootalebi-yWwob8kwOCk-unsplash.webp";
import { IoIosCheckmarkCircle } from "react-icons/io";

import { ContactSection } from "../../Components/ContactSection/ContactSection";
import { Helmet } from "react-helmet-async";
import { WhyChooseDataDept } from "../../Components/WhyChooseClifster/WhyChooseClifster";
import { useNavigate } from "react-router-dom";

export const About = (prop) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    prop.setSelectedPage("about");
  }, []);

  return (
    <>
      <Helmet>
        <title>
          About Us - DataDept | Your Trusted Partner in Innovative Software
          Solutions
        </title>
        <meta
          name="description"
          content="Discover custom software solutions at DataDept: Tailored CRM, mobile apps, SaaS, and IT consulting services designed to drive your business forward."
        />
        <link rel="canonical" href="/about-us" />
      </Helmet>
      <section className="about-page-section-1 container-style">
        <div className="content-sizing about-page-section-1-wrapper">
          <div className="header-into-about-section">
            <Reveal delay={0.1}>
              <span className="light-tag">About Us</span>
            </Reveal>
            <Reveal delay={0.2}>
              <h1 className="header-tag-about">
                Elevating Your Business with Cutting-Edge Tech Solutions
              </h1>
            </Reveal>
            <Reveal delay={0.3}>
              <h2 className="sub-header-tag-about">
                At DataDept, we're pioneering the future of digital innovation
                by crafting bespoke software solutions that empower businesses
                to transcend their conventional boundaries.
              </h2>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="about-page-section-2 container-style">
        <div className="content-sizing about-page-section-2-wrapper">
          <div className="about-box-company-header">
            <div className="header-left-about-2">
              <span className="small-tag">Our Company</span>
              <h2>What's our mission?</h2>
              <p>Contact us to Elevate Your Business!</p>
            </div>

            <Button onClick={() => navigate("/contact-us")}>Contact Us</Button>
          </div>

          <img src={officeImg} alt="office" loading="lazy" />
          <Reveal delay={0.1}>
            <p className="text-about-section-2">
              Our mission is simple yet ambitious: to empower businesses,
              entrepreneurs, and visionaries by turning their ideas into reality
              through robust, scalable, and innovative software solutions. We
              are dedicated to pushing the boundaries of what's possible, using
              the latest technologies to build solutions that are not just
              effective but also future-proof.
            </p>
          </Reveal>
          <ul className="list-about-section-2">
            <li>
              <IoIosCheckmarkCircle />{" "}
              <h2>Precision-Crafted Software Solutions </h2>
            </li>
            <li>
              <IoIosCheckmarkCircle /> <h2>Innovative Web Applications </h2>
            </li>
            <li>
              <IoIosCheckmarkCircle /> <h2>IT Consulting for Transformation</h2>
            </li>
          </ul>
        </div>
      </section>

      <WhyChooseDataDept />

      <section className="how-we-work container-style">
        <Reveal>
          <div className="content-sizing stats-numbers">
            <Reveal>
              <div className="header-info-stats-box support-box">
                <span className="small-tag">SUPPORT</span>
                <h2>Need any further assistance?</h2>
                <p className="support-box-section">
                  Feel free to reach out for any inquiries or assistance.
                </p>
                <Button onClick={() => prop.setIsOpen(true)}>
                  Book an appointment now
                </Button>
              </div>
            </Reveal>

            <img
              decoding="async"
              src="https://wpriverthemes.com/synck/wp-content/uploads/2023/11/bg-shape-1-1.svg"
              alt="Shape"
              class="slide-left"
              loading="lazy"
            />
          </div>
        </Reveal>
      </section>
    </>
  );
};
